module.exports = __webpack_public_path__ + "img/Arabic-01.33b6048b.jpg";